import {
  computed,
} from "vue";
import {
  useStore,
} from "vuex";

import KontextTypes from "../const/KontextTypes";
import store from "../../store";
import {
  getProfile,
} from "./HttpAPI";
import {
  isString,
  isArray,
  indexOf,
  isUndefined,
  forEach,
  cloneDeep,
} from "lodash-es";


export default function PermissionAPI() {
  const store = useStore();
  const me = computed(() => {
    return cloneDeep(store.getters["profile/GET_ME"] || {});
  });


  const isAuthenticatedSync = computed(() => {
    return !!(me.value && me.value.pk);
  });

  const fullName = computed(() => {
    if (!isAuthenticatedSync.value) {
      return "";
    }
    const parts = [];
    if (me.value.n_vorname) {
      parts.push(me.value.n_vorname);
    }
    if (me.value.n_nachname) {
      parts.push(me.value.n_nachname);
    }
    if (parts.length === 0) {
      parts.push(me.value.n_loginname);
    }
    return parts.join(" ");
  });

  const _checkPermissionsSync = ({ perm, permArray }) => {
    return checkPermissionsSync({ perm, permArray });
  };

  const hasOnePermissions = ({ perm = [], permArray }) => {
    for (let i = 0; i < perm.length; i++) {
      if (_checkSinglePermissions({ perm: perm[i], permArray })) {
        return true;
      }
    }
    return false;
  };

  const checkContextTypeSync = ({ contextType }) => {
    if (isUndefined(contextType)) {
      return true;
    }

    if (isUndefined(me.value) || !me.value.kontexte) {
      return false;
    }
    for (let i = 0; i < me.value.kontexte.length; i++) {
      if (me.value.kontexte[i].kontext_typ === KontextTypes[contextType]) {
        return true;
      }
    }
    return false;
  };

  const preparePermissionsList = ({ response }) => {
    const PERMISSIONS_LIST = [];
    const PERMISSIONS_OBJ = {};
    forEach(response, fGroup => {
      forEach(fGroup.berechtigungen, permission => {
        if (!PERMISSIONS_OBJ[permission.key]) {
          PERMISSIONS_LIST.push(permission);
          PERMISSIONS_OBJ[permission.key] = true;
        }
      });
    });
    return PERMISSIONS_LIST;
  };

  return {
    checkContextTypeSync,
    checkPermissionsSync: _checkPermissionsSync,
    fullName,
    hasOnePermissions,
    isAuthenticatedSync,
    me,
    preparePermissionsList,
  };
}

export function checkPermissionsSync({ perm, permArray }) {
  if (isUndefined(perm) || (isArray(perm) && !perm.length)) {
    return true;
  }
  let permArrayLocal = [];
  if (permArray) {
    permArrayLocal = permArray;
  } else {
    const ME = store.state.profile.ME;
    if (ME && ME.permissions) {
      permArrayLocal = ME.permissions;
    }
  }
  return _checkPermissionsWithArray({ perm, permArray: permArrayLocal });
}

function _checkPermissionsWithArray({ perm, permArray }) {
  if (isString(perm)) {
    return _checkSinglePermissions({ perm, permArray });
  } else if (isArray(perm)) {
    return _checkArrayPermissions({ perm, permArray });
  }
  return false;
}

function _checkArrayPermissions({ perm, permArray }) {
  for (let i = 0; i < perm.length; i++) {
    const CURRENT_PERM = perm[i];
    if (permArray.indexOf(CURRENT_PERM) === -1) {
      return false;
    }
  }
  return true;
}

function _checkSinglePermissions({ perm, permArray }) {
  return isArray(permArray) && indexOf(permArray, perm) !== -1;
}

export function checkPermissions(perm) {
  return new Promise(resolve => {
    getProfile().then(
      response => {
        if (!response || !isArray(response.permissions)) {
          resolve(false);
        } else {
          resolve(_checkPermissionsWithArray({ perm, permArray: response.permissions }));
        }
      },
      () => {
        resolve(false);
      }
    );
  });
}
